// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Profile form inside shared post-payment flow shell */

.adhoc-flow .adhoc-profile-form {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.adhoc-flow .profile-form {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.adhoc-flow .profile-fields {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 8px;
}

.adhoc-flow .profile-icon-wrap {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: var(--flow-paper);
  border: 1px solid var(--flow-line);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  color: var(--flow-teal);
}

.adhoc-flow .profile-title {
  margin-bottom: 8px;
}

.adhoc-flow .profile-desc {
  margin-bottom: 14px;
}

.adhoc-flow .profile-list {
  margin: 0 0 20px;
  padding: 0;
  list-style: none;
  font-size: 13px;
  color: var(--flow-ink-soft);
  line-height: 1.65;
}

.adhoc-flow .profile-list li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.adhoc-flow .profile-list li::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--flow-teal);
  flex-shrink: 0;
  margin-top: 8px;
}

.adhoc-flow .profile-footer {
  margin-top: 20px;
  border-top: 1px solid var(--flow-line);
  padding-top: 16px;
  text-align: center;
}

.adhoc-flow .profile-footer p {
  font-size: 11px;
  color: var(--flow-ink-soft);
  line-height: 1.5;
  margin: 0;
}

.adhoc-flow .profile-email-hint {
  font-size: 13px;
  color: var(--flow-ink-soft);
  margin-top: 8px;
  line-height: 1.5;
}
`, "",{"version":3,"sources":["webpack://./src/components/adhoc/profile.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["/* Profile form inside shared post-payment flow shell */\n\n.adhoc-flow .adhoc-profile-form {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n.adhoc-flow .profile-form {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n.adhoc-flow .profile-fields {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  padding-bottom: 8px;\n}\n\n.adhoc-flow .profile-icon-wrap {\n  width: 52px;\n  height: 52px;\n  border-radius: 14px;\n  background: var(--flow-paper);\n  border: 1px solid var(--flow-line);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 18px;\n  color: var(--flow-teal);\n}\n\n.adhoc-flow .profile-title {\n  margin-bottom: 8px;\n}\n\n.adhoc-flow .profile-desc {\n  margin-bottom: 14px;\n}\n\n.adhoc-flow .profile-list {\n  margin: 0 0 20px;\n  padding: 0;\n  list-style: none;\n  font-size: 13px;\n  color: var(--flow-ink-soft);\n  line-height: 1.65;\n}\n\n.adhoc-flow .profile-list li {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.adhoc-flow .profile-list li::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--flow-teal);\n  flex-shrink: 0;\n  margin-top: 8px;\n}\n\n.adhoc-flow .profile-footer {\n  margin-top: 20px;\n  border-top: 1px solid var(--flow-line);\n  padding-top: 16px;\n  text-align: center;\n}\n\n.adhoc-flow .profile-footer p {\n  font-size: 11px;\n  color: var(--flow-ink-soft);\n  line-height: 1.5;\n  margin: 0;\n}\n\n.adhoc-flow .profile-email-hint {\n  font-size: 13px;\n  color: var(--flow-ink-soft);\n  margin-top: 8px;\n  line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
